module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-react-helmet-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://www.flexport.com","noQueryString":true,"include":["^/route-search($|/.*)","^/atlas($|/.*)","^/sign-up/?$","^/talk-to-an-expert/?$","^/get-started/?$","^/terms-and-conditions($|/.*)","^/emissions-calculator/?$","^/help/?$","^/open-emissions-signup/?$","^/paps/?$","^/pars/?$","^/privacy/?$","^/search/?$","^/resources/authors($|/.*)","^/resources/[^/]+/?$","^/help/[^/]+/?$","^/products/cargo-insurance($|/.*)","^/rates($|/.*)"]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"9c023c8f698cf55181b00bc25dcaa562"},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
